module.exports = __webpack_public_path__ + "img/0x2bF9b864cdc97b08B6D79ad4663e71B8aB65c45c.cfcb5c88.png";